module.exports = __webpack_public_path__ + "media/images/hapier1-e495b44767a00474dee7cc29957cf738.jpg";